import { render, staticRenderFns } from "./CardResponsaveis.vue?vue&type=template&id=ce26806c&scoped=true&"
import script from "./CardResponsaveis.vue?vue&type=script&lang=js&"
export * from "./CardResponsaveis.vue?vue&type=script&lang=js&"
import style0 from "./card_responsaveis.scss?vue&type=style&index=0&id=ce26806c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce26806c",
  null
  
)

export default component.exports